/**
 * True si dbName corresponde al tenant (prod o copia test / variante).
 * Usa contains case-insensitive para que duntower-test, fobtrading-test, etc.
 * activen la misma lógica que la BD de producción del tenant.
 * @param {string} dbName
 * @param {string} tenantName
 * @returns {boolean}
 */
export function dbNameMatchesTenant(dbName, tenantName) {
  const n = String(dbName || "").trim().toLowerCase();
  const t = String(tenantName || "").trim().toLowerCase();
  if (!n || !t) return false;
  return n.includes(t);
}

/**
 * True si dbName encaja con algún tenant de la lista (visibleIn/hiddenIn).
 * '*' = todos.
 * @param {string} dbName
 * @param {string[]|undefined|null} tenantList
 * @returns {boolean}
 */
export function dbNameInTenantList(dbName, tenantList) {
  if (!Array.isArray(tenantList) || tenantList.length === 0) return false;
  for (const entry of tenantList) {
    const t = String(entry || "").trim();
    if (!t) continue;
    if (t === "*") return true;
    if (dbNameMatchesTenant(dbName, t)) return true;
  }
  return false;
}
